module.exports = __webpack_public_path__ + "img/heatmap.354ccae1.svg";